import { Controller } from "stimulus"
import Recorder from "../packs/recorder"

export default class extends Controller {

    seconds = 0;
    minutes = 0;
    hours = 0;
    timeOut;
    audioContext
    recordButton
    stopButton
    pauseButton
    uploadRadioButton
    recordRadioButton
    duration = 0;
    gumStream;
    rec;
    input;

    initialize() {
        if (document.getElementById("audio")) {
            document.getElementById("audio").addEventListener("loadedmetadata", () => {
                this.duration = Math.floor(document.getElementById("audio").duration);
                document.getElementById("podcast_recorder_max_value").max = this.duration;
                document.getElementById("podcast_recorder_max_value").value = this.duration;
                document.getElementById("podcast_recorder_min_value").max = this.duration - 1;
            }, false);
        } else {
            this.recordButton = document.getElementById("recordButton");
            this.stopButton = document.getElementById("stopButton");
            this.pauseButton = document.getElementById("pauseButton");
            this.uploadRadioButton = document.getElementById("podcast_recorder_choice_true");
            this.recordRadioButton = document.getElementById("podcast_recorder_choice_false");
        }
    }

    updateDuration() {
        let max_value = document.getElementById("podcast_recorder_max_value");
        let min_value = document.getElementById("podcast_recorder_min_value");
        max_value.min = Math.min(this.duration, Number(min_value.value) + 1);
        min_value.max = Math.min(this.duration, Number(max_value.value) - 1);
    }

    toggleChoice() {
        if (this.uploadRadioButton.checked) {
            document.getElementById("upload").classList.remove("hidden");
            document.getElementById("record").classList.add("hidden");
        } else {
            document.getElementById("upload").classList.add("hidden");
            document.getElementById("record").classList.remove("hidden");
        }
    }

    startRecording() {
        var constraints = { audio: true, video: false }
        this.recordButton.disabled = true;
        this.recordButton.classList.add("hidden");
        this.stopButton.disabled = false;
        this.stopButton.classList.remove("hidden");
        this.pauseButton.disabled = false
        this.pauseButton.classList.remove("hidden")
        navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
            this.timer();
            this.audioContext = new AudioContext();
            this.gumStream = stream;
            this.input = this.audioContext.createMediaStreamSource(stream);
            this.rec = new Recorder(this.input, { numChannels: 1 })
            this.rec.record()
        });
    }

    pauseRecording() {
        if (this.rec.recording) {
            this.rec.stop();
            this.pauseButton.innerHTML = "Resume";
            clearTimeout(this.timeOut);
        } else {
            this.rec.record()
            this.pauseButton.innerHTML = "Pause";
            this.timer();
        }
    }

    stopRecording() {
        this.stopButton.disabled = true;
        this.recordButton.classList.remove("hidden");
        this.recordButton.disabled = false;
        this.stopButton.classList.add("hidden");
        this.pauseButton.disabled = true;
        this.pauseButton.classList.add("hidden");
        this.pauseButton.innerHTML = "Pause";
        this.rec.stop();
        this.gumStream.getAudioTracks()[0].stop();
        this.rec.exportWAV(this.createDownloadLink);
        clearTimeout(this.timeOut);
        document.getElementById("duration").innerText = "00:00:00";
        this.seconds = 0;
        this.minutes = 0;
        this.hours = 0;
    }

    createDownloadLink(blob) {
        var url = URL.createObjectURL(blob);
        var audio = document.createElement('audio');
        audio.id = "audio"
        var li = document.createElement('li');
        var link = document.createElement('a');
        var div = document.createElement('div');
        var filename = new Date().toISOString();
        audio.controls = true;
        audio.src = url;
        audio.style.display = "inline-block";
        audio.classList = "w-full sm:w-2/3 p-2";
        link.download = filename + ".wav";
        link.href = url;
        link.innerHTML = "Download";
        link.style.display = "inline-block";
        link.classList = "sm:float-right text-center py-4 px-8 leading-none text-white bg-blue-500 hover:bg-blue-600 rounded shadow mt-3 sm:m-0 ml-6"
        div.classList = "w-full my-3";
        div.appendChild(audio);
        div.appendChild(link);
        li.append(div);
        li.appendChild(document.createTextNode(" "))
        document.getElementById("recordingsList").appendChild(li);
    }

    add() {
        this.seconds++;
        if (this.seconds >= 60) {
            this.seconds = 0;
            this.minutes++;
            if (this.minutes >= 60) {
                this.minutes = 0;
                this.hours++;
            }
        }
        document.getElementById("duration").innerText = (this.hours ? (this.hours > 9 ? this.hours : "0" + this.hours) : "00") + ":" + (this.minutes ? (this.minutes > 9 ? this.minutes : "0" + this.minutes) : "00") + ":" + (this.seconds > 9 ? this.seconds : "0" + this.seconds);
        this.timer();
    }

    timer() {
        this.timeOut = setTimeout(() => {
            this.seconds++;
            if (this.seconds >= 60) {
                this.seconds = 0;
                this.minutes++;
                if (this.minutes >= 60) {
                    this.minutes = 0;
                    this.hours++;
                }
            }
            document.getElementById("duration").textContent = (this.hours ? (this.hours > 9 ? this.hours : "0" + this.hours) : "00") + ":" + (this.minutes ? (this.minutes > 9 ? this.minutes : "0" + this.minutes) : "00") + ":" + (this.seconds > 9 ? this.seconds : "0" + this.seconds);
            this.timer();
        }, 1000);
    }

    processVideo(event) {
        if (document.getElementById("podcast_recorder_max_value").checkValidity() && document.getElementById("podcast_recorder_min_value").checkValidity()) {
            event.target.innerText = "Processing";
        }
    }
}